module.exports = __webpack_public_path__ + "static/gallery42-7b50ce0a3b8a2aee01f9cbbab3bc53c0.png";